<template>
  <i
    :class="iconClass"
    :style="iconStyle"
  >
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m19.23 15.26-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.045 15.045 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 0 0-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98Z"/></svg>
    <!-- eslint-enable -->
  </i>
</template>

<script>
import BaseIcon from '../BaseIcon.vue';

export default {
  name: 'DpIconPhone',
  extends: BaseIcon,
  iconName: 'phone',
  iconCategory: 'action',
};
</script>
